import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "jspdf-autotable";
import moment from "moment";
import Select from "react-select";

import { getApi } from "../../../../utils/apiHelper";
import { getLevel } from "../../../../utils/CommonFunction";
import apiRoutes from "../../../../utils/apiRoutes";
import Button from "./Button";

const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class SalaryTemplateTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: props.data,
      levelStatus: null,
      level: [],
      serach_data: [],
      viewHistory: false,
      isFetchingHistory: false,
      salarySlipsHistoryData: [],
    };
  }
  async componentDidMount() {
    this.setState({ dataSource: this.props.data }, () =>
      this.showTable(this.state.dataSource)
    );
    let level = await getLevel();
    level.unshift({ label: "All", value: 0 });
    this.setState({
      level: level,
    });
  }
  handleSelectedlevelStatus = async (event) => {
    let levelStatus = this.state.levelStatus;
    levelStatus = event;
    this.setState({
      levelStatus: levelStatus,
    });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState(
        {
          dataSource: this.props.data,
        },
        () => {
          this.showTable(this.state.dataSource);
        }
      );
    }
  }

  handleSearchData = () => {
    const { dataSource, levelStatus } = this.state;
    if (!levelStatus) return toast.error("Please select level!");

    this.setState(
      {
        serach_data:
          levelStatus && levelStatus.value === 0 // ALL
            ? dataSource
            : dataSource.filter(
                (v) => v.career_level === levelStatus.value * 1
              ),
      },
      () => {
        this.showTable(this.state.serach_data);
      }
    );
  };

  handleClickViewHistory = async () => {
    const { isFetchingHistory, viewHistory, salarySlipsHistoryData } =
      this.state;
    if (isFetchingHistory) return;

    if (viewHistory) {
      return this.setState(
        {
          viewHistory: false,
          dataSource: this.props.data,
          levelStatus: null,
        },
        () => {
          this.showTable(this.state.dataSource);
        }
      );
    }

    this.setState({
      isFetchingHistory: true,
    });

    try {
      const { data } = await getApi(apiRoutes.salaryTemplateHistory);

      this.setState(
        {
          isFetchingHistory: false,
          viewHistory: true,
          salarySlipsHistoryData: data,
          dataSource: data,
          levelStatus: null,
        },
        () => {
          this.showTable(this.state.dataSource);
        }
      );
    } catch (error) {
      this.setState({
        isFetchingHistory: false,
      });
      this.props.showToast(400, "Something went wrong. Unable to get data.");
    }
  };

  showTable(data) {
    var table;
    var self = this;
    var list = [];
    var obj,
      one = [];
    const { level_options, sub_level_options } = this.props;

    for (let i = 0; i < data.length; i++) {
      obj = data[i];
      one = {
        no: i + 1,
        date: obj.date ? moment(obj.date).format("MM-DD-YYYY") : "",
        basic_salary: obj.basic_salary,
        career_level: level_options.find(
          (v) => Number(v.career_level_id) === Number(data[i].career_level)
        )
          ? level_options.find(
              (v) => Number(v.career_level_id) === Number(data[i].career_level)
            ).career_level
          : "",
        career_sub_level: sub_level_options.find(
          (v) =>
            Number(v.career_sub_level_id) === Number(data[i].career_sub_level)
        )
          ? sub_level_options.find(
              (v) =>
                Number(v.career_sub_level_id) ===
                Number(data[i].career_sub_level)
            ).career_sub_level
          : "",
        remark: obj.remark ? obj.remark : "-",
      };

      list.push(one);
    }

    if ($.fn.dataTable.isDataTable("#dataTables")) {
      table = $("#dataTables").dataTable({
        destroy: true,
        searching: false,
      });
      table.fnDestroy();
    }

    var column = [
      { title: "No", data: "no" },
      { title: "Date", data: "date" },
      { title: "Basic Salary", data: "basic_salary" },
      { title: "Career Level", data: "career_level" },
      { title: "Career Sub Level", data: "career_sub_level" },
      { title: "Remark", data: "remark" },
    ];

    table = $("#dataTables").DataTable({
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf"],
      data: list,
      columns: column,
      stripeClasses: [],
    });

    $("#dataTables").on("click", "tbody #verify_by", function (e) {
      const id = e.target.attributes.id.value;
      const index = Number(e.target.attributes.index.value);
      const value_ = e.target.attributes.value.value;
      let newArr = [...self.state.leavePermissionData];
      newArr[index][id] = value_;
      self.setState({ leavePermissionData: newArr }, () => {
        document.getElementById(`verify_by${index}`).innerHTML = value_;
      });
    });
  }

  render() {
    return (
      <div>
        <ToastContainer position={toast.POSITION.TOP_RIGHT} />
        <div className="row">
          <h3
            className="col-md-12"
            style={{
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            Salary Template Table
            {this.state.viewHistory && (
              <span style={{ color: "red" }}> (History)</span>
            )}
          </h3>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex" }}>
            <Select
              styles={{
                container: (base) => ({
                  ...base,
                  width: 150,
                  marginBottom: 20,
                }),
                control: (base) => ({
                  ...base,
                  minHeight: "18px",
                }),
              }}
              placeholder="Level"
              options={this.state.level}
              onChange={this.handleSelectedlevelStatus}
              value={this.state.levelStatus}
              className="react-select-container"
              classNamePrefix="react-select"
            />
            <Button label="Search" onClick={this.handleSearchData} />
          </div>
          <Button
            label={this.state.viewHistory ? "View Current" : "View History"}
            onClick={this.handleClickViewHistory}
            isDisabled={this.state.isFetchingHistory}
          />
        </div>
        <table
          width="99%"
          className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive rm-marginTop"
          id="dataTables"
        ></table>
      </div>
    );
  }
}
